/**
 * BilgiKartlari — Alarm bilgi kartları (Karar Destek Paneli).
 *
 * Sadece tetiklenen alarmlar gösterilir (max 5). Saf veri, sebep/çözüm önerisi YOK.
 *
 * Props:
 *   kartlar: alarm_uret() çıktısı listesi
 *   onDrill: (path) => void
 */
import React from 'react';
import { useTheme } from '../../styles/ThemeProvider';

const SEVERITY_STYLES = {
  danger:  { bg: '#fff5f5', border: '#dc3545', label: '!' },
  warning: { bg: '#fff8e1', border: '#ffc107', label: '⚠' },
  info:    { bg: '#e7f5ff', border: '#0d6efd', label: 'i' },
};

export default function BilgiKartlari({ kartlar, onDrill }) {
  const { theme } = useTheme();

  if (!kartlar || kartlar.length === 0) {
    return null; // Hiç alarm yoksa banda yer kaplama
  }

  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: theme.space.sm }}>
      {kartlar.map((kart, idx) => {
        const sev = SEVERITY_STYLES[kart.severity] || SEVERITY_STYLES.info;
        return (
          <div
            key={`${kart.kod}-${idx}`}
            onClick={kart.drill_link && onDrill ? () => onDrill(kart.drill_link) : undefined}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: theme.space.md,
              padding: `${theme.space.sm}px ${theme.space.md}px`,
              background: sev.bg,
              borderLeft: `4px solid ${sev.border}`,
              borderRadius: theme.radius.sm,
              cursor: kart.drill_link && onDrill ? 'pointer' : 'default',
              fontSize: 14,
            }}
          >
            <div style={{
              width: 24, height: 24, borderRadius: '50%',
              background: sev.border, color: 'white',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, fontSize: 14, flexShrink: 0,
            }}>
              {sev.label}
            </div>
            <div style={{ flex: 1, color: theme.color.text }}>{kart.metin}</div>
            {kart.drill_link && onDrill && (
              <div style={{ fontSize: 12, color: sev.border, fontWeight: 600 }}>Detay →</div>
            )}
          </div>
        );
      })}
    </section>
  );
}
